const BLOCKCOLORS = {
  1: "#FFFFEC",
  2: "#F1E4C3",
  3: "#C6A969",
  4: "#597E52",
  5: "#ECF4D6",
  6: "#9AD0C2",
  7: "#265073",
};

const COLORS = {
  NavbarBlack: "#141414",
};

export { BLOCKCOLORS, COLORS };
